import { TemplatePage } from './types';

const observancesPage: TemplatePage = {
  header: {
    color: '#FED7D8',
    icon: 'images/video-templates/observances.jpg',
    title: 'Observances Video Templates Collection',
    title_meta: '100+ Free and Customizable Observances Video Templates',
    description_meta:
      'Celebrate various observances and national days with your online audience using Wave.video’s 100+ ' +
      'easy-to-customize video templates.',
    description:
      'Celebrate various observances and national days with your online audience using these easy-to-customize ' +
      'video templates. Easily create videos that your audience will love!'
  },
  footer: {
    category: 'Observances',
    description:
      'Wave.video’s collection of observances video templates helps easily create fun marketing videos for your ' +
      'social media, website, email newsletter, or blog. All these templates are easy and free to customize to ' +
      'match your brand.'
  },
  content: [
    {
      type: 'templates',
      title: 'Observances Videos',
      search: {
        category: '/Holidays & Occasions/Observances'
      }
    },
    {
      type: 'stocks',
      title: 'Observances',
      search: {
        name: 'observances'
      }
    },
    { type: 'calendar' }
  ]
};

export default observancesPage;
